import { type MetaFunction } from "react-router";
import { Link } from "react-router";
import { z } from "zod";
import { RVFInput } from "~/components/RVF/RVFInput";
import { RVFSubmitButton } from "~/components/RVF/RVFSubmitButton";
import { useState } from "react";
import { Turnstile } from "@marsidev/react-turnstile";
import { useForm } from "@rvf/react";
import axios from "axios";
import { toast } from "react-toastify";
import { handleErrorClient } from "~/helpers";

export const meta: MetaFunction = () => {
  return [{ title: "RollCall2 - Forgot Password" }];
};

export const validator = z.object({
  email: z
    .string()
    .trim()
    .min(1, { message: "Required!" })
    .email("Invalid email address"),
  "cf-turnstile-response": z.string(),
});

export default function ForgotPasswordPage() {
  const [status, setStatus] = useState<string>("");
  const [isSuccessful, setIsSuccessful] = useState(false);

  const onSubmit = async (values: z.infer<typeof validator>) => {
    const toSubmit = {
      email: values.email,
      cfTurnstileResponse: values["cf-turnstile-response"],
    };

    try {
      const response = await axios.post<{ message: string }>(
        "/auth/request-reset",
        toSubmit,
      );
      if (response.data.message === "Check Email") {
        setIsSuccessful(true);
        form.resetForm();
        return response.data;
      }
    } catch (error) {
      const message = await handleErrorClient(error);
      toast.error(message);
    }
  };

  const form = useForm({
    schema: validator,
    defaultValues: {
      email: "",
      "cf-turnstile-response": "",
    },
    handleSubmit: async (data) => {
      return onSubmit(data);
    },
  });

  // const seed = async () => {
  //   try {
  //     const res = await axios.post("/api/seed");
  //     toast.success(res.data.message);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  return (
    <div className="min-h-[600px] w-full">
      <h1 className="text-center text-4xl max-md:text-3xl">
        Attendance Made Easy
      </h1>
      {/* <button type="button" onClick={seed}>
        Seed
      </button> */}
      <div className="flex flex-row flex-wrap justify-around justify-items-center">
        <div
          className="my-4 flex w-[320px] flex-initial flex-col items-center justify-start self-auto rounded-2xl border border-gray-500 p-3 dark:border-gray-500"
          id="forgot-form"
        >
          {isSuccessful ? (
            <>
              <h3>Check Your Email</h3>
              <p>A Confirmation email has been sent</p>
              <p className="text-sm text-amber-500 dark:text-amber-200">
                (Not there? Check the spam folder)
              </p>
            </>
          ) : (
            <>
              <h3 className="mb-2">Forgot Password</h3>
              <form {...form.getFormProps()} className="w-[275px]">
                <div className="flex flex-col gap-2">
                  <RVFInput
                    name="email"
                    label="Email"
                    type="text"
                    form={form}
                  />
                  <div className="flex items-center justify-center">
                    <Turnstile
                      siteKey="0x4AAAAAAA_370Mn2aEMBgHB"
                      onError={() => setStatus("error")}
                      onExpire={() => setStatus("expired")}
                      onSuccess={() => setStatus("solved")}
                    />
                  </div>
                  {status === "solved" && <RVFSubmitButton />}
                </div>
              </form>
              <Link id="login-link" to="/" className="text-xs">
                Back to Login
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
